import { Injectable } from '@angular/core';


@Injectable()

export class LocalStorageService {

  constructor() {}

  get<T>(key: string): T {
    return JSON.parse(sessionStorage.getItem(key)) || JSON.parse(localStorage.getItem(key));
  }

  set<T>(key: string, payload: T, persistance: boolean = true): void {
    if (persistance) {
      localStorage.setItem(key, JSON.stringify(payload));
    } else {
      sessionStorage.setItem(key, JSON.stringify(payload));
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  removeAll(): void {
    localStorage.clear();
  }

  compare<T>(key: string, payload: T): boolean {
    if (JSON.stringify(payload) === localStorage.getItem(key)) {
      return true;
    }

    localStorage.setItem(key, JSON.stringify(payload));
    return false;
  }

}
